import { TextField } from '@mui/material';
import styled from 'styled-components';
import { theme } from '../../themes/theme';
export const MaskedInputTextField = styled(TextField) `
  .MuiInputBase-input {
    padding: 3px 0 7px;
  }
  text-transform: capitalize;
`;
export const AdornmentWrapper = styled.span `
  margin-bottom: 4px;
  font-size: 14px;
  color: ${theme.palette.text.secondary};
`;
export const FileInputWrapper = styled.div `
  position: relative;
`;
export const FileInputHelperText = styled.span `
  display: block;
  font-size: 13px;
  color: ${theme.palette.text.secondary};
  position: absolute;
  margin-top: 0.5rem;
  height: 1rem;
`;
export const ErrorMessageWrapper = styled.span `
  display: block;
  margin-top: 0.25rem;
  position: absolute;
`;
